import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loggedIn: true,
    video: {
      title: "Thundercats vs. Lions, Tigers and Bears",
      date: "11/13/19",
      stream: "https://www.firemammoth.com/sample/full_view.m3u8",
      type: "url",
      teams: [{
          name: "Broncos"
        },
        {
          name: "Thundercats"
        }
      ],
      field: {
        name: "St. Mary's"
      },
      gameEvents: [{
          title: "Broncos Goal 1",
          position: 37.36
        },
        {
          title: "Broncos Goal 2",
          position: 41.76
        }
      ],
      virtualDirector: [
        [0, 1, 0, 0, 100],
        [45, 1, 0.1, 0, 100],
        [105, 240, 0.3, 0, 130],
        [400, 120, 0.5, 0, 120],
        [600, 310, 0.5, 0, 200],
        [960, 10, 0.7, 0, 150],
        [1070, 300, 0.88, 0, 100],
        [1420, 1, 0.38, 0, 100],
        [1621, 60, -0.08, 0, 100],
        [1740, 1, 0.08, 0, 100],
        [1950, 1, 0.15, 0, 100]
      ]
    },
    player: {
      viewMode: "VirtualDirector",
      swapVMOnPlay: false,
      jumpPosition: false,
      recording: false,
      playing: false,
      hasPlayed: false,
      seeking: false,
      canZoom: null,
      contentType: "event"
    },
    parentEvent: {},
    hilites: [],
    mode: "player",
    editor: {
      video: {
        clipManifest: {},
        musicId: null,
        title: "",
        thumbnail: "",
        virtualDirector: [
          [0, 0, 0, 0, 0]
        ],
        customVirtualDirector: []
      },
      player: {
        viewMode: "VirtualDirector",
        swapVMOnPlay: false,
        jumpPosition: false,
        recording: false,
        playing: false,
        hasPlayed: false,
        seeking: false,
        canZoom: null,
        contentType: "event"
      },
      vdPositions: [],
      music: [{
          title: "Hit the Road",
          filename: "hit-the-road_by_veshza_Artlist",
          id: 1,
          format: "mp3",
          lengths: [
            4, 8, 12, 16
          ]
        },
        {
          title: "No Matter How Hard We Try",
          filename: "no-matter-how-hard-we-try---instrumental-version_by_moon_Artlist",
          id: 2,
          format: "mp3",
          lengths: [
            4, 8, 12, 16
          ]
        }
      ]
    }
  },
  mutations: {
    logInOut(state, status) {
      state.loggedIn = status;
    },
    setViewMode(state, viewMode) {
      state.player.viewMode = viewMode;
    },
    setStream(state, stream) {
      state.video.stream = stream;
    },
    setJump(state, jumpPosition) {
      state.player.jumpPosition = jumpPosition;
    },
    setContentType(state, contentType) {
      state.player.contentType = contentType;
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setHiLite(state, hilite) {
      if (state.player.contentType !== "hilite") {
        state.player.contentType = "hilite";
        //save original event video for later
        state.parentEvent = state.video;
      }
      state.video = hilite;
    },
    setEvent(state, event) {
      if (state.player.contentType !== "event") {
        state.player.contentType = "event";
      }
      state.video = event;
    },
    setEditor(state, clip) {
      if (clip) {
        state.editor.video.clipManifest = clip;
      }
      state.editor.video.virtualDirector = state.video.virtualDirector;
      state.editor.video.title = "";
      state.editor.video.type = "json";
      state.mode = "editor";
    },
    setEditorClips(state, clips) {
      state.editor.video.clipManifest.segments = _.cloneDeep(clips);
    },
    addHiLite(state, video) {
      state.hilites.push(video);
      state.mode = "player";
    }
  }
});

export default store;
